/* eslint-disable max-len */
import { observer } from 'mobx-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { useRef } from 'react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useStore } from '../../../../../../core/utils/hook';
import { VideoPlayer } from '../../../../../../components';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { IconPauseVideo, ImgPointSvg, ImgVideoMockupTransparen } from './IconVideo';

const VideoSlideComponent = observer(({ slides }) => {
    // ref
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const breakpoints = {
        480: {
            slidesPerView: 1
        },
        768: {
            slidesPerView: 2
        },
        1024: {
            slidesPerView: 3
        }
    };

    return (
        <div className="video-slide-wrapper">
            <Swiper
                onInit={(swiper) => {
                    setTimeout(() => {
                        if (swiper.params?.navigation) {
                            if (typeof swiper.params.navigation !== 'boolean') {
                                swiper.params.navigation.prevEl = prevRef.current;
                                swiper.params.navigation.nextEl = nextRef.current;
                                swiper.navigation.init();
                                swiper.navigation.update();
                            }
                        }
                    });
                }}
                slidesPerView={1}
                spaceBetween={30}
                breakpoints={breakpoints}
                modules={[Pagination, Navigation]}
                pagination={{
                    clickable: true,
                    el: '.custom-pagination'
                }}
                navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current
                }}
                onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                }}
                className="swiper-video-sample"
            >
                {Array.isArray(slides) &&
                    slides?.length > 0 &&
                    slides.map((slide, index) => (
                        <SwiperSlide key={index}>
                            <VideoCard slideItem={slide} />
                        </SwiperSlide>
                    ))}
            </Swiper>

            {/* Custom Navigation */}
            <div className="custom-navigation">
                <button
                    ref={prevRef}
                    className="custom-nav-button custom-nav-prev"
                    aria-label="Previous slide"
                >
                    <ChevronLeft strokeWidth={2.25} color='#FFF' />
                </button>

                <div className="custom-pagination"></div>

                <button
                    ref={nextRef}
                    className="custom-nav-button custom-nav-next"
                    aria-label="Next slide"
                >
                    <ChevronRight strokeWidth={2.25} color='#FFF' />
                </button>
            </div>
        </div>
    );
});

export default VideoSlideComponent;

const VideoCard = observer(({ slideItem }) => {
    // store
    const {
        modalStore: { show, hide }
    } = useStore();

    const ModalVideoContent = ({ video, isActive, thumbnail }) => {
        if (!video || !isActive) {
            return (
                <div className="not-show-video">
                    <img
                        src={'/images/img-1.png'}
                        alt=""
                        style={{ height: '100%', objectFit: 'fill' }}
                    />
                    <p>後にご覧いただけます。</p>
                </div>
            );
        }

        return (
            <VideoPlayer
                options={{
                    poster: thumbnail,
                    sources: [
                        {
                            src: video,
                            type: video.toLowerCase().includes('m3u8')
                                ? 'application/x-mpegURL'
                                : 'video/mp4'
                        }
                    ]
                }}
                width={1000}
                height={400}
                disableForward={false}
            />
        );
    };

    const onShowPlayVideo = async (video, fileName) => {
        const scrollYBeforeOpen = window.scrollY;
        show({
            id: 'modal-play-video-sample-movie',
            header: (
                <div className="line-clamp-1" style={{ wordBreak: 'break-all' }}>
                    {fileName}
                </div>
            ),
            isOpen: true,
            onCancel: () => {
                hide();
                setTimeout(() => {
                    window.scrollTo({
                        top: scrollYBeforeOpen,
                        behavior: 'instant' // or 'auto'
                    });
                }, 50);
            },
            children: (
                <div className="sample-movie-modal">
                    <ModalVideoContent
                        video={video?.url}
                        isActive={!!video?.isActive}
                        thumbnail={video?.thumbnailUrl}
                    />
                </div>
            ),
            type: 'medium max-width-800'
        });
    };

    return (
        <div
            className="video-card"
            style={{
                position: 'relative',
                backgroundColor: '#fff',
                overflow: 'hidden'
            }}
        >
            <div className="video-container">
                <div className="video-wrapper">
                    {(slideItem?.video?.url && slideItem?.video?.isActive === true) ? (
                        <>
                            <VideoPlayer
                                options={{
                                    poster: slideItem?.video?.thumbnailUrl,
                                    sources: [
                                        {
                                            src: slideItem?.video?.url,
                                            type: slideItem?.video?.url?.toLowerCase()?.includes('m3u8')
                                                ? 'application/x-mpegURL'
                                                : 'video/mp4'
                                        }
                                    ]
                                }}
                                disableForward={false}
                            />
                        </>
                    ) : (
                        <img
                            src={'/images/img-1.png'}
                            alt=""
                            style={{
                                // height: '100%',
                                objectFit: 'fill'
                            }}
                        />
                    )}
                    {/* <VideoPlayer
                        options={{
                            sources: [
                                {
                                    src: slideItem?.video?.url,
                                    type: slideItem?.video?.url?.toLowerCase()?.includes('m3u8')
                                        ? 'application/x-mpegURL'
                                        : 'video/mp4'
                                }
                            ]
                        }}
                        disableForward={true}
                    /> */}

                    <div className="video-overlay">
                        {/* <img src="/images/i-pause-video.png" alt="" style={{ width: 58 }} /> */}
                        <IconPauseVideo />
                    </div>
                </div>
            </div>

            {/* Mockup */}
            {/* <img
                src="/images/video-mockup-transparen.png"
                alt=""
                style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    position: 'relative',
                    zIndex: 4,
                    verticalAlign: 'middle',
                    cursor: 'pointer'
                }}
                className="img-television"
                onClick={() => onShowPlayVideo(slideItem?.video)}
            /> */}

            <ImgVideoMockupTransparen
                className='img-television'
                onClick={() => onShowPlayVideo(slideItem?.video)}
            />

            {/* Content */}
            <div className="video-card__content">
                <div className="triangle-wrapper triangle-wrapper-top">
                    <div className="triangle"></div>
                </div>
                <div className="triangle-wrapper triangle-wrapper-bottom">
                    <div className="triangle"></div>
                </div>
                {/* <div className="video-card__content__img">
                    <img src="/images/video-sample-point.png" alt="" />
                </div> */}
                <ImgPointSvg className="video-card__content__img" />
                <div className="video-card__content__desc" style={{ whiteSpace: 'pre-wrap' }}>
                    {slideItem?.explanatory}
                </div>
            </div>
        </div>
    );
});
